import { createBrowserRouter } from 'react-router-dom';

// routes
import MainRoutes from './MainRoutes';
import LoginRoutes from './LoginRoutes';
import CandidateRoutes from './CandidateRoutes';
import GuestRoutes from './GuestRoutes';

// ==============================|| ROUTING RENDER ||============================== //

const router = createBrowserRouter([LoginRoutes, MainRoutes, CandidateRoutes, GuestRoutes], {
    basename: process.env.REACT_APP_BASE_NAME
});

export default router;
